import { render, staticRenderFns } from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=template&id=4821e090&scoped=true"
import script from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=script&lang=js"
export * from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=style&index=0&id=4821e090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821e090",
  null
  
)

export default component.exports